import { Icon } from "@iconify/react/dist/iconify.js";
import ConfiguracionTalentosGlobal from "../../components/configuracionTalentos/ConfiguracionTalentosGlobal";
import VideoTutorialInicioQuiz from "../../components/configuracionTalentos/VideoTutorialInicioQuiz";

const ConfiguracionGlobalTalentosPage = () => {
  return (
    <div className="container-fluid text-center">
      <div className="mb-3">
        <h3 className="mb-0 fw-semibold">Configuración adicional</h3>
       
      </div>

      <div className="row g-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm radius-8">
            <div className="card-header border-bottom bg-base py-3 px-4">
              <div className="d-flex align-items-center gap-2">
                <span className="bg-primary bg-opacity-10 rounded-circle p-2">
                  <Icon
                    icon="mdi:star-outline"
                    width={20}
                    className="text-primary"
                  />
                </span>
                <div className="text-start">
                  <h6 className="mb-0 fw-semibold">Configuración de talentos</h6>
                  <small className="text-muted">
                    Define cuántos talentos más y menos destacados se mostrarán
                    en los resultados del algoritmo para todos los planteles.
                  </small>
                </div>
              </div>
            </div>
            <div className="card-body py-4 px-4">
              <ConfiguracionTalentosGlobal />
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="card border-0 shadow-sm radius-8">
            <div className="card-header border-bottom bg-base py-3 px-4">
              <div className="d-flex align-items-center gap-2">
                <span className="bg-primary bg-opacity-10 rounded-circle p-2">
                  <Icon
                    icon="mdi:play-circle-outline"
                    width={20}
                    className="text-primary"
                  />
                </span>
                <div className="text-start">
                  <h6 className="mb-0 fw-semibold">
                    Video tutorial de inicio del quiz
                  </h6>
                  <small className="text-muted">
                    Configuración global del video introductorio que verán todos
                    los estudiantes antes de comenzar el quiz.
                  </small>
                </div>
              </div>
            </div>
            <div className="card-body py-4 px-4">
              <VideoTutorialInicioQuiz />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracionGlobalTalentosPage;

